import {
  HeightRule,
  Paragraph,
  Table,
  TableCell,
  TableRow,
  WidthType,
  TableLayoutType,
} from "docx";
import Options from "../../../data/options";
import {
  tableCellMain,
  tableCellMainCenter,
  tableCellMainRight,
  tableCellWithColSpan,
  tableCellWithRowSpan,
  tableCellWithRowSpanBorders,
  tableCellWithTextArray,
  tableCellWithTextArrayExpanded,
} from "./tableCell";
import {
  textbausteinTypes,
  textbausteinTypes1,
} from "../../Textbausteine/textbausteinTypes";
import { getTextbausteinArray } from "./functions";
import Calculations from "../../../helpers/calculations";
import { noten } from "../../../data/noten";

export const mainTable1 = (user, klausur, schueler, textbausteine) => {
  console.log({ user, klausur, schueler });
  console.log("###################################", textbausteinTypes.afb1Tb);
  return new Table({
    layout: TableLayoutType.FIXED, // Layout auf "fixed" setzen
    columnWidths: [2500, 6500, 1000],
    width: {
      size: 100,
      type: WidthType.PERCENTAGE,
    },

    rows: [
      new TableRow({
        cantSplit: true,
        height: { value: 300, rule: HeightRule.AUTO },
        children: [
          tableCellMain("Kategorie"),
          tableCellMain("Bewertung"),
          tableCellMain("Punkte"),
        ],
      }),

      new TableRow({
        cantSplit: true,
        height: { value: 300, rule: HeightRule.AUTO },
        children: [
          tableCellMain(
            `${textbausteinTypes1.afb1Tb.long} (${klausur.prozentAfb1} %)`
          ),
          tableCellWithTextArrayExpanded(
            getTextbausteinArray(schueler.afb1Tb, textbausteine),
            schueler.afb1Remarks
          ),
          tableCellMain(schueler.afb1Points),
        ],
      }),
      new TableRow({
        cantSplit: true,
        height: { value: 300, rule: HeightRule.AUTO },
        children: [
          tableCellMain(
            `${textbausteinTypes1.afb2Tb.long} (${klausur.prozentAfb2} %)`
          ),
          //   tableCellMain(schueler.afb2Tb),
          tableCellWithTextArrayExpanded(
            getTextbausteinArray(schueler.afb2Tb, textbausteine),
            schueler.afb2Remarks
          ),
          tableCellMain(schueler.afb2Points),
        ],
      }),
      new TableRow({
        cantSplit: true,
        height: { value: 300, rule: HeightRule.AUTO },
        children: [
          tableCellMain(
            `${textbausteinTypes1.afb3Tb.long} (${klausur.prozentAfb3} %)`
          ),
          //   tableCellMain(schueler.afb3Tb),
          tableCellWithTextArrayExpanded(
            getTextbausteinArray(schueler.afb3Tb, textbausteine),
            schueler.afb3Remarks
          ),
          tableCellMain(schueler.afb3Points),
        ],
      }),
    ],
  });
};
